let FailMainLevelGiftBagRedirector = xClass("FailMainLevelGiftBagRedirector", BaseRedirector)
FailMainLevelGiftBagRedirector.prototype.getName = function () {
    return "giftbag_invite";
}
FailMainLevelGiftBagRedirector.prototype.redirect = function () {
    let param = this.param;

    let um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }

    if (!_G.isGetNewUserReward) {
        if (!_G.kIsNewUser) {
            console.log("不是新玩家");
            return;
        } else {
            console.log("是新玩家");
        }
        
        let uid = um.uid;     
        let inviteCode = param["inviteCode"];
        let shareId = param["shareId"];
        let isMyself = inviteCode && inviteCode === uid || false
        
        if (isMyself) {
            //  没有单独配置文本，直接用相同的
            Toast.make(getText("coin.match.share.self"));
            return true;
        }
        
        return new Promise((resolve, reject)=> {        
            let http = LevelEndShareGiftClickHttp.new()
            http.addEventListener(Events.kComplete, function (evt) {
                console.log("成功帮助好友增加次数");
                _G.isGetNewUserReward = true;
                resolve(evt.data)
            })
            http.addEventListener(Events.kError, function (evt) {
                Toast.make(quickGetErrorText(evt.data), 0.5, function () {})
                console.log("帮助好友增加次数失败");
                reject(evt.data)
            })
            http.addEventListener(Events.kCancel, function (evt) {
                Toast.make(quickGetErrorText(evt.data), 0.5, function () {})
                console.log("帮助好友增加次数失败");
                reject(evt.data)
            })
            http.load(inviteCode, shareId);
        });
    }else{
        return false
    }
}

FailMainLevelGiftBagRedirector.prototype.hasHighPriorityAction = function () {
    return false;
}

module.exports = FailMainLevelGiftBagRedirector